"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.forwardEvent = void 0;
exports.handleAnalyticsEventsFromPartialView = handleAnalyticsEventsFromPartialView;
exports.initGtm = initGtm;
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _internals = require("./internals");
var _types = require("./types");
const GOOGLE_TAG_MANAGER_PATH = '//www.googletagmanager.com/gtm.js?id=';
let model;
function createDataLayer() {
  if (typeof window.dataLayer === 'undefined') {
    window.dataLayer = [];
  }
  if (typeof window.gtag === 'undefined') {
    window.gtag = (...params) => window.dataLayer?.push(...params);
  }
}
function createGoogleTagManagerScript() {
  const script = document.createElement('script');
  script.async = true;
  script.src = GOOGLE_TAG_MANAGER_PATH + model.GtmId;
  document.head.insertAdjacentElement('afterbegin', script);
}

/** Standard GTM initialization event. */
function pushGtmStartEvent() {
  const data = {
    event: _types.GTM_START_EVENT,
    [_types.GTM_START]: Date.now()
  };
  window.dataLayer?.push(data);
}

/**
 * Records basic user and other context data information.
 *
 * This is being called only in Online where the server-side serialized
 * configuration contains the needed data.
 *
 * In ASMS, the context-data custom event will be called instead on client
 * with a slightly different timing, containing the same data.
 */
function pushContextDataEvent() {
  // Exit in ASMS page case where the data is not available from server.
  if (typeof model.CustomerId !== 'number') {
    return;
  }
  // TO-DO: workaround until the serialization on server is updated
  const customerId = model.CustomerId === 0 ? -1 : model.CustomerId;
  const data = {
    consultantId: model.ConsultantId ?? 0,
    customerId,
    customerTypeId: model.CustomerTypeId ?? 0,
    event: _types.CONTEXT_DATA_EVENT,
    periodId: Number(model.PeriodId)
  };
  window.dataLayer?.push(data);
}

/**
 * Records additional mobile application info based on cookies
 * when the page is being rendered as a part of mobile app page.
 */
function pushMobileCookies() {
  const data = {};
  _types.cookieNames.forEach(cookieName => {
    const tempCookie = _jsCookie.default.get(cookieName);
    if (tempCookie) {
      data[cookieName] = tempCookie;
    }
  });
  if (Object.keys(data).length > 0) {
    window.dataLayer?.push(data);
  }
}

/**
 * Records info about a successfully finished consultant registration process.
 * This works in Online based on session object logic in BE code.
 * TO-DO: The Online session object should be avoided & common solution
 * for Online & ASMS pages should be implemented later.
 */
function pushRegisteredConsultantEvent() {
  const data = {
    consultantId: model.ConsultantId ?? 0,
    event: _types.REGISTERED_CONSULTANT_EVENT,
    registeredConsultantId: model.RegisteredConsultantNumber ?? '',
    registrationType: model.RegistrationType ?? '',
    sponsorNumber: model.SponsorNumber ?? ''
  };
  window.dataLayer?.push(data);
}

/**
 * Records info about a successfully finished user registration process.
 * This works in Online based on session object logic in BE code.
 * TO-DO: The Online session object should be avoided & common solution
 * for Online & ASMS pages should be implemented later.
 */
function pushRegisteredUserEvent() {
  const data = {
    customerTypeId: model.RegisteredCustomerTypeId ?? 0,
    event: _types.REGISTERED_USER_EVENT,
    registeredUserId: model.RegisteredConsultantNumber ?? '',
    registrationChannel: model.RegistrationChannel ?? '',
    registrationType: model.RegistrationType ?? '',
    sponsorNumber: model.SponsorNumber ?? '',
    signUpDate: model.RegistrationSingUpDate ?? '',
    visitorSegment: model.RegistrationVisitorSegment ?? 0
  };
  window.dataLayer?.push(data);
}

/**
 * Records info about a successfully finished user login process.
 * This works in Online based on session object logic in BE code.
 * TO-DO: The Online session object should be avoided & common solution
 * for Online & ASMS pages should be implemented later.
 */
function pushLoginEvent() {
  const data = {
    consultantId: model.ConsultantId ?? 0,
    event: _types.LOGIN_EVENT,
    loginType: model.LoginType ?? null
  };
  window.dataLayer?.push(data);
}

/**
 * Records info about a successfully finished user upgrade process.
 * This works in Online based on session object logic in BE code.
 * TO-DO: The Online session object should be avoided & common solution
 * for Online & ASMS pages should be implemented later.
 */
function pushCustomerUpgradedEvent() {
  const data = {
    customerNewType: model.CustomerTypeIdAfterUpgrade ?? null,
    customerOldType: model.CustomerTypeIdBeforeUpgrade ?? null,
    event: _types.UPGRADED_USER_EVENT,
    upgradedUserId: model.ConsultantId ?? 0
  };
  window.dataLayer?.push(data);
}

/** Optionally records particular user state changes if the needed data is available. */
function pushUserStateChangedEvents() {
  if (model.IsLoggedInEvent) {
    void (0, _internals.domReadyPromise)().then(pushLoginEvent, undefined);
  }
  if (model.IsConsultantRegistrationEvent) {
    void (0, _internals.domReadyPromise)().then(pushRegisteredConsultantEvent, undefined);
  }
  if (model.IsCustomerRegistrationEvent) {
    void (0, _internals.domReadyPromise)().then(pushRegisteredUserEvent, undefined);
  }
  if (model.IsCustomerUpgradeEvent) {
    void (0, _internals.domReadyPromise)().then(pushCustomerUpgradedEvent, undefined);
  }
}

/** Initialization of GTM analytics channel. */
function initGtm(data) {
  model = data;
  createDataLayer();
  createGoogleTagManagerScript();
  pushGtmStartEvent();
  pushContextDataEvent();
  pushMobileCookies();
  pushUserStateChangedEvents();
}

/** Implementation of event forwarding into GTM. */
const forwardEvent = event => {
  const data = {
    event: event.detail.originalEventType,
    ...event.detail.originalEventDetail
  };
  window.dataLayer?.push(data);
};
exports.forwardEvent = forwardEvent;
function handleAnalyticsEventsFromPartialView(data) {
  model = data;
  pushUserStateChangedEvents();
}
